const steps = {
    namespaced: true,

    state: {
        one: {
            active: true,
            valid: false,
            showErrors: false,
        },
        two: {
            active: false,
            valid: false,
            showErrors: false,
        },
        three: {
            active: false,
            valid: false,
            showErrors: false,
        },
        four: {
            active: false,
            valid: false,
            showErrors: false,
        }
    },

    getters: {

    },

    mutations: {
        valid(state, payload) {
            state[payload.step].valid = payload.value
        },

        active(state, payload) {
            state[payload.step].active = payload.value
        },

        showErrors(state, payload) {
            state[payload.step].showErrors = payload.value
        },
    }

}

export default steps
